import React from 'react';
import { styled, Stack } from '@mui/material';

export const HelpContentList = styled((props: any) => (
    <Stack spacing={1} {...props} />
  ))(() => ({
    justifyContent: "flex-start",
    marginTop: 30
  }))

  export const HelpContentItem = styled('div')({
    paddingLeft: "10px",
    color: "#0259AB",
    width: "100%",
    cursor: 'pointer'
  })

  export const HelpTitleRow = styled((props: any) => (
    <Stack direction="row" spacing={2} {...props} />
  ))(() => ({
    justifyContent: 'space-between',
    width: "100%"
  }))
  
  export const HelpTitle = styled('div')({
    paddingRight: "10px",
    textAlign: "left",
    width: "90%"
  })

  export const HelpArrow = styled('div')({
    textAlign: "right",
    width: "10%"
  })

  export const HelpContentLink = styled("div")({
    paddingLeft: "30px"
  })

  